module.exports = __webpack_public_path__ + "media/icon/icon-arrow-left-black-6ef32578.svg";